<template>
	<div class="question">
		<span class="title">
			{{ question.title }}
		</span>

		<div class="analysis" v-if="analysis">
			<span class="option" v-for="response in analysis[question.title]"
				:key="response.key"
				v-bind:class="{ max: (response.value == analysis[question.title][0].value ) }">
				{{ getResponseName(response.key) }} (x{{ response.value }})

				<!-- TODO <el-popover
				    placement="bottom"
				    width="200"
				    trigger="hover">
					Show some analysis for the individual response, show a potential automated reply
				    <span slot="reference"></span>
				</el-popover> -->
			</span>
		</div>
	</div>
</template>

<script>
import BODYMAP from '../../../../util/get-bodymap'

export default {
	name: 'patient-symptom-card-response',

	props: {
		question: {
			type: Object,
			required: true
		},
		analysis: {
			type: Object
		}
	},

	data() {
		return {

		}
	},

	methods: {
		getResponseName(key) {
			if(this.question.type === 'human_map')
				return BODYMAP[key] ? BODYMAP[key].name : key
			return key
		}
	}
}
</script>

<style lang="scss" scoped>
.question {
	position: relative;
	min-height: 24px;
	padding: 0px 5px 5px 5px;

	.title {
		position: absolute;
		left: 15px;
		top: 6px;
		width: 100px;
		text-align: right;
		font-weight: 500;
		font-size: 12px;
		color: #6f6f6f;
	}

	.analysis {
		padding-left: 120px;
		font-size: 14px;
		line-height: 22px;
		min-height: 28px;
		padding-bottom: 3px;
		border-bottom: solid 1px #e0e0e0;

		span {
			margin-right: 4px;
			padding: 2px 3px;
			border-radius: 2px;
			color: #4f4f4f;
		}
		span.max {
			background: #e7e7e7;
			color: #3f3f3f;
			font-weight: 500;
		}
	}
}
</style>
